import React, { FC, ReactElement, FormEvent, useState } from 'react';
import { sendQuestionMessage } from '../../../api';
import Modal from 'react-modal';
import Icon from '../../Icon';
import './question-modal.sass';
import { useSelector } from 'react-redux';
import { getEventKey } from '../../../stores/reducers/userData';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { internalizationState } from '../../../stores/reducers/sections';
import localeFieldResolver from '../../../helpers/locale-field-finder';

Modal.setAppElement('#root');

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  recepient?: string;
}

const QuestionModal: FC<Props> = ({ isOpen, closeModal, recepient }): ReactElement => {
  const [ message, setMessage ] = useState<string>('');
  const eventKey = useSelector(getEventKey);
  const location = useLocation();
  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    successMessageSend_ru: 'Сообщение успешно отправлено',
    successMessageSend_en: 'Message sent successfully',
    errorMessageSend_ru: 'Ошибка отправки сообщения',
    errorMessageSend_en: 'Error sending message',
    askQuestion_ru: `Задать вопрос ${recepient ? recepient : ''}`,
    askQuestion_en: `Ask a question ${recepient ? recepient : ''}`,
    messagePlaceholder_ru: 'Сообщение',
    messagePlaceholder_en: 'Message',
    send_ru: 'Отправить',
    send_en: 'Send',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);


  const handlerSend = ((event: FormEvent): void => {
    event.preventDefault();
    const payload = {
      page: location.pathname.split('/')[1],
      to: recepient,
      message
    };
    
    sendQuestionMessage(eventKey, payload)
      .then(response => {
        if (response.status === 200) {
          toast.success(localizedName('successMessageSend_ru'));
        } else {
          toast.error(localizedName('errorMessageSend_ru'));
        }
      })
      .catch(error => {
        toast.error(localizedName('errorMessageSend_ru'));
      })
      .finally(() => handlerClose());
  })

  const handlerClose = (): void => {
    closeModal();
    setMessage('');
  };

  const updateMessageState = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value);
  };

  return (
    <>
    <Modal
      className="modal-login-content"
      overlayClassName="modal-login-overlay"
      isOpen={isOpen}
      onRequestClose={handlerClose}
    >
      <h3 className="modal-title">{ localizedName('askQuestion_ru') }</h3>
      <button className="modal-close" type="button" onClick={handlerClose}>
        <Icon name="close" />
      </button>
      <form className="modal-form" onSubmit={(e) => handlerSend(e)}>
        <textarea
          id="message"
          className="ui-input modal-textarea"
          placeholder={ localizedName('messagePlaceholder_ru') }
          value={message}
          onChange={updateMessageState}
        />
        <div className="form-buttons">
          <button
            type="submit"
            className="btn btn-primary bg-header"
            disabled={!message}
          >
            { localizedName('send_ru') }
          </button>
        </div>
      </form>
    </Modal>
    </>
  )
}

export default QuestionModal
